import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import ServiceProcess from "./sections/ServiceProcess";
import Coverage from "./sections/Coverage";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <ServiceProcess />
      <Coverage />
      <Consultation />
      <Footer />
    </div>;
}